import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["labelDisplay", "labelInput", "amountDisplay", "amountInput", "dateDisplay", "dateInput"]
  static values = {
    entryId: Number,
    label: String,
    amount: Number,
    date: String,
    url: String
  }

  connect() {
    if (this.hasLabelInputTarget) {
      this.labelInputTarget.value = this.labelValue
      this.labelInputTarget.addEventListener('click', (e) => e.stopPropagation())
    }
    if (this.hasAmountInputTarget) {
      this.amountInputTarget.value = (this.amountValue / 100).toFixed(2)
      this.amountInputTarget.addEventListener('click', (e) => e.stopPropagation())
    }
    if (this.hasDateInputTarget) {
      this.dateInputTarget.value = this.dateValue
      this.dateInputTarget.addEventListener('click', (e) => e.stopPropagation())
    }
    this.editMode = false
  }

  stopPropagation(event) {
    console.log('stopPropagation called on', event.target)
    event.stopPropagation()
  }

  editRow(event) {
    if (event.target.closest('.dropdown') || event.target.closest('button')) {
      return
    }

    if (this.editMode) {
      return
    }

    this.editMode = true
    this.element.classList.add('editing')

    setTimeout(() => {
      this.labelDisplayTarget.style.display = 'none'
      this.labelInputTarget.style.setProperty('display', 'inline-block', 'important')

      this.dateDisplayTarget.style.display = 'none'
      this.dateInputTarget.style.setProperty('display', 'inline-block', 'important')

      this.amountDisplayTarget.style.display = 'none'
      this.amountInputTarget.style.setProperty('display', 'inline-block', 'important')

      this.labelInputTarget.focus()
      this.labelInputTarget.select()
    }, 10)
  }

  cancelAll() {
    this.editMode = false
    this.element.classList.remove('editing')

    this.labelInputTarget.value = this.labelValue
    this.labelDisplayTarget.style.display = 'inline'
    this.labelInputTarget.style.display = 'none'

    this.amountInputTarget.value = (this.amountValue / 100).toFixed(2)
    this.amountDisplayTarget.style.display = 'inline'
    this.amountInputTarget.style.display = 'none'

    this.dateInputTarget.value = this.dateValue
    this.dateDisplayTarget.style.display = 'inline'
    this.dateInputTarget.style.display = 'none'
  }

  saveLabel() {
    setTimeout(() => {
      const activeElement = document.activeElement
      if (activeElement === this.dateInputTarget || activeElement === this.amountInputTarget) {
        return
      }

      const newLabel = this.labelInputTarget.value.trim()

      if (!newLabel || newLabel === this.labelValue) {
        this.cancelAll()
        return
      }

      this.updateEntry({ label: newLabel })
    }, 100)
  }

  saveAmount() {
    setTimeout(() => {
      const activeElement = document.activeElement
      if (activeElement === this.labelInputTarget || activeElement === this.dateInputTarget) {
        return
      }

      const newAmount = parseFloat(this.amountInputTarget.value)

      if (isNaN(newAmount) || newAmount === (this.amountValue / 100)) {
        this.cancelAll()
        return
      }

      this.updateEntry({ amount_cents: newAmount })
    }, 100)
  }

  saveDate() {
    setTimeout(() => {
      const activeElement = document.activeElement
      if (activeElement === this.labelInputTarget || activeElement === this.amountInputTarget) {
        return
      }

      const newDate = this.dateInputTarget.value

      if (!newDate || newDate === this.dateValue) {
        this.cancelAll()
        return
      }

      this.updateEntry({ checked_at: newDate })
    }, 100)
  }

  updateEntry(params) {
    const formData = new FormData()

    if (params.label !== undefined) {
      formData.append('finance_entry[label]', params.label)
    }
    if (params.amount_cents !== undefined) {
      formData.append('finance_entry[amount_cents]', params.amount_cents)
    }
    if (params.checked_at !== undefined) {
      formData.append('finance_entry[checked_at]', params.checked_at)
    }

    fetch(this.urlValue + '.json', {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: formData
    })
    .then(response => {
      if (response.ok) {
        window.location.reload()
        this.cancelAll()
      } else {
        console.error('Error updating entry:', response.statusText)
        this.cancelAll()
      }
    })
    .catch(error => {
      console.error('Error updating entry:', error)
      this.cancelAll()
    })
  }
}

